module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/logo-05027c9a513306f455226a75219f9d3e.png";